import { UseToastOptions } from "@chakra-ui/react";

export const toastDefaults: UseToastOptions = {
  duration: 5000,
  isClosable: true,
  position: "bottom-right",
};
